import { LocalStorage } from '@pi/ui';
import { type MturkFeedbackData } from 'src/pages/Mturk/useMturkFeedbackData';

import type { AggregateFormState } from 'src/pages/UIv2/AggregatePage/types';
import type { Moment } from 'moment';

export type GcpTokenType = {
    token: string;
    expirationDate: Moment;
};
/** Which credential the current session is built on. Absent means the native email/password login. */
export type AuthProvider = 'auth0';

export interface LocalStorageType {
    darkMode: boolean;
    jwt: string;
    authProvider: AuthProvider | null;
    gcpToken: GcpTokenType;
    mturkFeedback: MturkFeedbackData;
    pinnedTaskDefinition: string | null;
    navCollapsed: boolean;
    aggregatePipeline: AggregateFormState;
    formBuilder: {
        debug: {
            value: boolean;
            errors: boolean;
            config: boolean;
        };
    };
}

const LS = new LocalStorage<LocalStorageType>({
    namespace: 'admin_v2',
    getDefaults: () => ({
        jwt: '',
        authProvider: null,
        darkMode: false,
        navCollapsed: false,
        formBuilder: {
            debug: {
                value: true,
                config: true,
                errors: true,
            },
        },
    }),
});

export default LS;

if (process.env.NODE_ENV === 'development') {
    (window as any).LS = LS;
}
